import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Classes from './Pricing.module.css';

/* ─────────────── Icons ─────────────── */
const TickBlue = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
  </svg>
);

/* ──────────── Motion Variants ──────────── */
const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.15 }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

const card = {
  hidden: { opacity: 0, y: -12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};
/* ───────────────────────────────────────── */

const Pricing = () => {
  const sectionRef = useRef(null);
  const navigateTo = useNavigate();

  return (
    <motion.section
      id="pricing"
      ref={sectionRef}
      className={Classes.hero}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
    >
      {/* Heading */}
      <motion.div className={Classes.miniText} variants={fadeUp}>
        Pricing
      </motion.div>

      <motion.h1 className={Classes.subheading} variants={fadeUp}>
        Choose Your Plan
      </motion.h1>

      <motion.p className={Classes.text} variants={fadeUp}>
        Mentors set the price. You choose who to book — simple and transparent.
      </motion.p>

      {/* Boxes */}
      <div className={Classes.boxesList}>
        {/* Mentors box */}
        <motion.div custom={0} variants={card}>
          <div className={Classes.boxWhite}>
            <div className={Classes.bgPopup}>
              <div></div>
              <h5>Mentors</h5>
              <div className={Classes.curveCon}></div>
            </div>

            <h5 className={Classes.priceText}>
              <span>Receive</span> 80% <span> from each meeting</span>
            </h5>

            <hr />

            <div className={Classes.list}>
              {[
                'Set your own meeting prices',
                'Access to matchmaking',
                'Custom profile builder',
                'Messaging and scheduling'
              ].map((txt, i) => (
                <div key={i} className={Classes.listItem}>
                  <div className={Classes.blueTick}>
                    <TickBlue width="12px" height="12px" fill="white" />
                  </div>
                  <h5 className={Classes.text2}>{txt}</h5>
                </div>
              ))}
            </div>

            <motion.div
              className={Classes.blueBtn}
              whileTap={{ scale: 0.97 }}
              whileHover={{ scale: 1.03 }}
              onClick={() => navigateTo('/join/mentor')}
            >
              <h4>Become a Mentor</h4>
            </motion.div>
          </div>
        </motion.div>

        {/* Mentees box */}
        <motion.div custom={1} variants={card}>
          <div className={Classes.boxBlue}>
            <div className={Classes.bgPopup}>
              <div></div>
              <h5>Mentees</h5>
              <div className={Classes.curveCon}></div>
            </div>

            <h5 className={Classes.priceText}>
              $5.00 <span>flat fee + rate each meeting</span>
            </h5>

            <hr />

            <div className={Classes.list}>
              {[
                'Transparent mentor pricing',
                'Access to matchmaking',
                'Custom profile builder',
                'Messaging and scheduling'
              ].map((txt, i) => (
                <div key={i} className={Classes.listItem}>
                  <div className={Classes.whiteTick}>
                    <TickBlue width="12px" height="12px" fill="white" />
                  </div>
                  <h5 className={Classes.text2}>{txt}</h5>
                </div>
              ))}
            </div>

            <motion.div
              className={Classes.whiteBtn}
              whileTap={{ scale: 0.97 }}
              whileHover={{ scale: 1.03 }}
              onClick={() => navigateTo('/join/mentee')}
            >
              <h4>Become a Mentee</h4>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Pricing;
